import { render, staticRenderFns } from "./TagListBlock.vue?vue&type=template&id=7f153e13&name=tag-list-block&"
import script from "./TagListBlock.vue?vue&type=script&lang=js&"
export * from "./TagListBlock.vue?vue&type=script&lang=js&"
import style0 from "./TagListBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports